import { Link } from "react-router-dom";
import { SearchX } from "lucide-react";
import { usePermissions } from "@/hooks/usePermissions";
import { getDefaultAdminRoute } from "@/routes/admin-route-registry";

export default function NotFoundPage() {
  const { userRole } = usePermissions();

  return (
    <div className="mx-auto max-w-xl rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-sm">
      <SearchX className="mx-auto h-10 w-10 text-slate-400" />
      <h1 className="mt-4 text-2xl font-black text-slate-900">
        Page not found
      </h1>
      <p className="mt-2 text-sm text-slate-500">
        This admin route does not exist or is no longer available.
      </p>
      <Link
        to={getDefaultAdminRoute(userRole)}
        className="mt-6 inline-flex rounded-xl bg-slate-900 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white"
      >
        Return to your console
      </Link>
    </div>
  );
}
